import styled from 'styled-components'

import { device } from 'src/Styled/variables'

export const SelectCurrency = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 24px;
  padding: 16px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.color.lightGrey};

  @media ${device.smallScreenMax} {
    flex-direction: column;
  }
`
export const FormGroupLabel = styled.span`
  margin-bottom: 8px;
  display: inline-block;
  color: ${({ theme }) => theme.color.darkGrey};
`
export const FormGroupField = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: auto;
  .ant-select {
    .ant-select-focused {
      .ant-select-selector {
        color: ${({ theme }) => theme.color.darkGrey};
        background-color: ${({ theme }) => theme.color.white};
        border-color: ${({ theme }) => theme.color.lightGrey} !important;
        box-shadow: none !important;
      }
    }
    .ant-select-focused {
      .ant-select-selector {
        color: ${({ theme }) => theme.color.darkGrey};
        background-color: ${({ theme }) => theme.color.white};
        border-color: ${({ theme }) => theme.color.lightGrey} !important;
      }
      .ant-select-open {
        color: ${({ theme }) => theme.color.darkGrey};
        background-color: ${({ theme }) => theme.color.white};
        border-color: ${({ theme }) => theme.color.lightGrey} !important;
        box-shadow: none !important;
      }
    }
    .ant-select-selector {
      font-size: 14px;
      color: ${({ theme }) => theme.color.darkGrey};
      background-color: ${({ theme }) => theme.color.white};
      border-radius: 8px;
      box-shadow: none !important;
      border-color: ${({ theme }) => theme.color.lightGrey} !important;
      input {
        height: 40px;
      }
      &:hover,
      &:focus,
      &:active {
        border-color: ${({ theme }) => theme.color.lightGrey} !important;
        box-shadow: none !important;
      }
    }
  }
`
export const FormDescription = styled.span`
  color: ${({ theme }) => theme.color.slateGrey};
`

export const Form = styled.form`
  max-width: 2000px;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
`
export const FormGroup = styled.div`
  margin-bottom: 15px !important;
  max-width: 400px;
  width: 100%;
  position: relative;
  @media ${device.mobileMin} {
    margin-bottom: 0 !important;
  }
`
